import React from 'react';
import { pickBy, includes, isEmpty, capitalize } from 'lodash';
import { Button, Checkbox } from '@weave/platform-ui-components';
import { TableStyles } from '../../../../../styles/table-style';
import ReactTable, { Column } from 'react-table';
import { css } from 'emotion';

import { orderNewNumberStyles } from '../order-new-number.styles';
import { Chip } from '@weave/design-system';
import { theme } from '@weave/theme';
import { AvailablePhoneNumber } from '@weave/schema-gen-ts/dist/schemas/phone/number-service/v2/number_service.pb';

const capabilityColorMap: Record<
  'voice' | 'sms' | 'mms' | 'fax',
  { background: string; color: string }
> = {
  voice: {
    background: theme.colors.primary30,
    color: theme.colors.primary90,
  },
  sms: {
    background: theme.colors.secondary.seaweed60,
    color: theme.colors.secondary.seaweed10,
  },
  mms: {
    background: theme.colors.warning50,
    color: theme.colors.black,
  },
  fax: {
    background: theme.colors.secondary.eggplant30,
    color: theme.colors.secondary.eggplant90,
  },
};

export interface AvailablePhoneNumbersTableProps {
  phoneNumbers: {
    availablePhoneNumbers: AvailablePhoneNumber[];
  };
  subtitleText?: string;
  selectedNumbers: string[];
  handlePurchaseChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  onPurchaseClick?: () => void;
  showPurchaseButton?: boolean;
}

export const AvailablePhoneNumbersTable: React.FC<AvailablePhoneNumbersTableProps> = ({
  phoneNumbers,
  subtitleText,
  selectedNumbers,
  handlePurchaseChange,
  loading,
  onPurchaseClick,
  showPurchaseButton = false,
}) => {
  const handlePurchaseClick = () => {
    if (onPurchaseClick) {
      onPurchaseClick();
    }
  };

  const columns: Column<AvailablePhoneNumber>[] = [
    {
      Header: 'Number',
      id: 'number',
      accessor: 'phoneNumber',
      width: 160,
    },
    {
      Header: 'Provider',
      id: 'provider',
      accessor: 'provider',
      Cell: ({ value }) => capitalize(value?.split('_')[1]),
    },
    {
      Header: '',
      id: 'select',
      accessor: (phoneNumber: AvailablePhoneNumber) => {
        return (
          <span className={orderNewNumberStyles.checkboxStyles}>
            <Checkbox
              checked={includes(selectedNumbers, phoneNumber.phoneNumber)}
              value={phoneNumber.phoneNumber}
              onChange={handlePurchaseChange}
            />
          </span>
        );
      },
    },
  ];

  return (
    <>
      {(showPurchaseButton || subtitleText) && (
        <div
          className={css`
            display: flex;
            align-items: baseline;
            justify-content: space-between;
          `}
        >
          <span>{subtitleText}</span>
          {showPurchaseButton && (
            <Button
              disabled={isEmpty(selectedNumbers)}
              onClick={handlePurchaseClick}
              className={css`
                display: inline-block !important;
              `}
            >
              Purchase
            </Button>
          )}
        </div>
      )}

      <ReactTable
        columns={columns}
        data={phoneNumbers.availablePhoneNumbers || []}
        sortable={false}
        loading={loading}
        pageSize={10}
        css={TableStyles}
      />
    </>
  );
};
